import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import CookiePrivacyPolicyPopup from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ScrollArrow from "@MasterBluePrint/Components/ScrollArrow";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import * as React from "react";
import { css } from "styled-components";

export interface FooterStyles {
    page?: MobiusPageProps;
}

export const footerStyles: FooterStyles = {
    page: {
        fullWidth: [true, true, true, true, true],
        background: themeColors.colorFooterBackground,
        css: css`
            color: ${themeColors.colorFooter};
            font-family: 'Roboto', sans-serif;
            font-size: ${themeFontSizes.size14};
            font-weight: 500;
            letter-spacing: -.014rem;
            line-height: 2.1875rem;
            background: ${themeColors.colorBlack},
            position: relative,
            overflow: visible,
            padding-bottom: 0,
            z-index: 99,
            max-width: 100%,
            box-shadow: 50em 0 0 0 ${themeColors.colorFooterBackground}, -50em 0 0 0 ${themeColors.colorFooterBackground},

            .scrollTop {
                position: absolute;
                height: 2.4375rem;
                width: 2.4375rem;
                right: 1.25rem;
                top: -20px !important;
                align-items: center;
                height: 1.25rem;
                border: 1px solid ${themeColors.colorPrimary};
                border-radius: 100%;
                background-color:  ${themeColors.colorYellow};
                justify-content: center;
                z-index: 99;
                cursor: pointer;
                animation: fadeIn .3s;
                transition: opacity .4s;
            }

            .scrollTop:hover {
                opacity: 1;
            }

            @keyframes fadeIn {
                0% {
                    opacity: 0;
                }
                100% {
                    opacity: .5;
                }
            }
        `,
    },
};
const styles = footerStyles;

const Footer = ({ id }: PageProps) => (
    <Page
        as="footer"
        {...styles.page}
        style={{
            position: "relative",
            overflow: "visible",
        }}
    >
        <Zone contentId={id} zoneName="Content" />
        <ScrollArrow {...styles.page} />
        <CookiePrivacyPolicyPopup />
    </Page>
);

const pageModule: PageModule = {
    component: Footer,
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;
export const FooterContext = "Footer";
